import { render, staticRenderFns } from "./RulesPage.vue?vue&type=template&id=58b7ca96&lang=pug&"
import script from "./RulesPage.vue?vue&type=script&lang=ts&"
export * from "./RulesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports